var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChecked3 = function SvgChecked3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 0.800003C4.0236 0.800003 0.799805 4.0238 0.799805 8C0.799805 11.9762 4.0236 15.2 7.9998 15.2C11.976 15.2 15.1998 11.9762 15.1998 8C15.1998 4.0238 11.976 0.800003 7.9998 0.800003ZM12.024 6.6242L7.488 11.1602C7.3752 11.273 7.2228 11.336 7.0638 11.336C6.9048 11.336 6.7518 11.273 6.6396 11.1602L4.5678 9.0884C4.3332 8.8538 4.3332 8.4746 4.5678 8.24C4.8024 8.0054 5.1816 8.0054 5.4162 8.24L7.0638 9.8876L11.1756 5.7758C11.4102 5.5412 11.7894 5.5412 12.024 5.7758C12.2586 6.0104 12.2586 6.3896 12.024 6.6242Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChecked3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checked-3.56111efac574cca3bbfe5e2db8015e28.svg";